import { Fragment } from 'react'
import clx from 'classnames'
import _ from 'lodash'
import styles from './CustomizedLegend.css'
import { EMPTY_VALUE } from '../../../../../../../constants/globalTypes'
import { getGroupByReportDateTypePayload } from '../ViewsChart'

const CustomizedLegend = props => {
  const { payload, align, summaries } = props
  const {
    mainRange = [],
    comparisonRange = []
  } = getGroupByReportDateTypePayload(payload, 'value')
  return (
    <div className={styles.Legend}>
      <div
        className={styles.centered}
        style={{ textAlign: align }}
      >
        {
          [mainRange, comparisonRange].map((payload, rowIndex) => {
            // 圖例如果有比較區間(多列)需要換行顯示
            return (
              <Fragment key={rowIndex}>
                {
                  rowIndex !== 0 &&
                    <br />
                }
                {
                  !_.isEmpty(comparisonRange) && (
                    <span
                      key={`title_${rowIndex}`}
                      className={styles.itemName}
                    >
                      {_.get(summaries, `${rowIndex}.title`, EMPTY_VALUE)}
                    </span>
                  )}
                {
                  payload.map((entry, itemIndex) => {
                    const { value, color } = entry
                    return (
                      <p
                        key={`item-${itemIndex}`}
                        className={clx(
                          styles.item,
                          { [styles.firstItem]: itemIndex === 0 }
                        )}
                      >
                        <span
                          style={{ backgroundColor: color }}
                          className={styles.icon}
                        />
                        {value}
                      </p>
                    )
                  })
                }
              </Fragment>
            )
          })
        }
      </div>
    </div>
  )
}

export default CustomizedLegend
